import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import PrivacyNotice from "./pages/PrivacyNotice";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";
import Dashboard from "./pages/Dashboard";
import './App.css';
import Test from "./pages/Test";



function App() {

  const [mode, setMode] = useState(
    localStorage.getItem("mode") || "light"
  ); // Initialize mode state

  const toggleMode = () => {
    const newMode = mode === "light" ? "dark" : "light";
    setMode(newMode);
  };

  return (
    <Router>
      <Routes>
        <Route path="/"  element={<HomePage toggleMode={toggleMode} mode={mode} />} />
        <Route path="/privacy" element={<PrivacyNotice toggleMode={toggleMode} mode={mode} />} />
        <Route path="/terms" element={<Terms toggleMode={toggleMode} mode={mode} />} />
        <Route path="/contact" element={<Contact toggleMode={toggleMode} mode={mode} />} />
        <Route path="/dashboard" element={<Dashboard toggleMode={toggleMode} mode={mode} />} />

        <Route path="/test" element={<Test/>} />

      </Routes>
    </Router>
  );
}

export default App;
